import React from 'react';
import { LeftMedia, Media, Navbar } from '../../components';
import { Footer, Header, Scroll } from '../../containers';
import './enterprise.css';
import Image1 from '../../assets/crypto-demo.png';
import LargeVideo from '../../components/media/largevideo';
import Trailer from "../../assets/etheware-space.mp4";

const Enterprise = () => {
  return (
    <div className='enterprise'>  
      <Navbar />
        <div className='page'>  
          <LargeVideo lgvideolink={Trailer} autoPlay muted loop controls={false} />
          
          <div className='space'/>
          
            <Media 
              topline={"Make the Impossible, Possible with ES Manager"}
              header={"Build Powerful Apps & Websites with ES Manager"}
              paragraph={"Begin designing high-ranking professional grade websites, softwares, crypto applications and mobile apps to suit your needs all with ES Manager. Building the future has never been easier."}
              btntxt={"Join the Waitlist"}
              btnlink={"/open-access-program"}
              lin1 = {Image1}
            />
          
          <Scroll />
            <Header />
          <LeftMedia 
            top={"Join our Early-Bird Research Team that focuses on Beta Testing new company applications, games, and technology."}
              header={"Join the Exclusive Etheware Open Access Program"}
              paragraph={"Each member will receive their name and Research role accredited on each application's credits page which is public. In addition to an Etheware verified certificate mailed to you, along with vouchers for members only exclusive events."}
              text={"Be some of the first in the world to test the most groundbreaking innovations we've seen in recent history alongside prominent researchers, developers, and founders."}
              button={"Join Now"}
              btn__link={"/waitlist"}
              video__link={require('../../assets/hologram.mp4')}
          />
  
        </div>   
        <Footer />
    </div>
  );
}

export default Enterprise;